import React, { Fragment } from 'react';
import _ from 'lodash';
import { replaceCountryTags } from '../helpers/mapUtils';
import Icon from './icon.svg';

const RecommendedVaccine = ({ vaccine, country }) => {
	return (
		<div className="recommended-vaccines-item">
			{vaccine.image ? <img src={vaccine.image} /> : null}
			<div className="recommended-vaccines-item-title">{vaccine.name}</div>
			{_.get(vaccine, 'transmitted_via', []).length > 0 ? (
				<Fragment>
					<div className="recommended-vaccines-item-subtitle">Transmitted via</div>
					{vaccine.transmitted_via.map(transmitter => (
						<span className="transmission" key={transmitter.name}>
							<span className={`icon icon--aquablue ${transmitter.icon}`} />
							<span className="transmission-name">{transmitter.name}</span>
						</span>
					))}
				</Fragment>
			) : null}
			<p>{replaceCountryTags(vaccine.description, country.name)}</p>
			<a href={vaccine.url} target="_blank" rel="noopener noreferrer" className="hyperlink hyperlink-default">
				Learn more
				<span dangerouslySetInnerHTML={{ __html: Icon }} />
			</a>
		</div>
	);
};

export default RecommendedVaccine;
